import type { IconData } from '@stacksjs/iconify-core'

export const handGestureFingerClick: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.135 21.33h1.53v7.62h-1.53Zm-1.52 7.62h1.52v1.53h-1.52Zm0-9.14h1.52v1.52h-1.52Zm-1.52 10.67h1.52V32h-1.52Zm0-12.19h1.52v1.52h-1.52Zm0 0v-1.53h-6.1v-6.09h-1.52v7.62zm-1.53-15.24h1.53v1.52h-1.53Zm-1.52 16.76h1.52v4.57h-1.52Zm0-15.24h1.52V6.1h-1.52Zm-1.52 1.53h1.52v1.52h-1.52Zm-3.05 13.71h1.52v4.57h-1.52Zm-3.05-10.67h3.05v1.53h-3.05ZM12.945 0h1.53v4.57h-1.53Zm-3.04 28.95h1.52V32h-1.52Zm0-6.09h1.52V10.67h-1.52v7.62h-3.05v1.52h3.05zm-1.53 4.57h1.53v1.52h-1.53Zm0-21.33h1.53v1.52h-1.53Zm-1.52 19.81h1.52v1.52h-1.52Zm0-21.34h1.52V6.1h-1.52Zm-1.52 15.24h1.52v6.1h-1.52Zm0-16.76h1.52v1.52h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handGestureFingerClick
